/** What the backend's `/health/` reports about the running build (issue #34).
 * `version` is the release (production only); `commit` the image's git SHA. */
export interface AppBuild {
  version: string | null;
  commit: string | null;
}

const SHORT_SHA_LENGTH = 7;

/** The label shown in the user menu: the release in production, otherwise
 * the environment and short commit (staging is not a release). */
export function appVersionLabel(build: AppBuild, environment: string | undefined): string | null {
  if (build.version) return build.version;
  if (!build.commit) return null;
  const sha = build.commit.slice(0, SHORT_SHA_LENGTH);
  return environment ? `${environment} · ${sha}` : sha;
}
